<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="setOfdData">
            <b-form-group :label="$t('kkm.kkmSfdNum')" label-cols-sm="3">
                <b-form-input v-model="formData.sfdNumber" disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.kkmId')" label-cols-sm="3">
                <b-form-input v-model="formData.ccmId" required  :state="isValid(formData.ccmId)" />
                <b-form-text> {{ $t('kkm.ofdDataRequirement') }} </b-form-text>
            </b-form-group>
            <b-form-group :label="$t('kkm.ofdToken')" label-cols-sm="3">
                <b-form-input v-model="formData.token" required :state="isValid(formData.token)" />
                <b-form-text> {{ $t('kkm.ofdDataRequirement') }} </b-form-text>
            </b-form-group>
            <b-form-group :label="$t('kkm.ofdSelectString')" label-cols-sm="3">
                <b-form-select v-model="formData.ofdConnectionString" :options="formData.options"></b-form-select>
            </b-form-group>
            <b-form-group :label="$t('kkm.ofdConnectionString')" label-cols-sm="3">
                <b-form-input v-model="formData.ofdConnectionString" required></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>
<script>
export default {
    name: 'KkmSetOfdDataForm',
    props: {
        sfdNum: String,
        ofdConnectionString: String
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                sfdNumber: this.sfdNum,
                ccmId: '',
                token: '',
                ofdConnections: '',
                options: [],
                ofdConnectionString: null
            }
        }
    },
    created() {
        this.formData.ofdConnections = JSON.parse(this.ofdConnectionString);
        this.formData.ofdConnectionString = this.formData.ofdConnections.active;

        this.formData.options.push({
            value: this.formData.ofdConnections["active"], text: this.$i18n.t('kkm.selectOfdConnection')
        });

        this.formData.ofdConnections["ofd"].forEach( item => {
            this.formData.options.push({
                value: item.url, text: `${item.url} (${item.name})`
            });
        });
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading || !this.isValid(this.formData.ccmId) || !this.isValid(this.formData.token);
        }
    },
    methods: {
        setOfdData: function () {
            this.showAlert = false
            this.showSuccessAlert = false

            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.setOfdData,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.ofdDataSetMessage')
                }, this.displayAlert)
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        },
        isValid(value) {
            if (!/^\d+$/.test(value)) return false;
             
            const numberValue = parseInt(value);

            return numberValue >= 0 && numberValue <= 4294967295;
        }
    }
}
</script>
